import { useMutation } from 'react-query';
import { UseMutationOptions } from 'service/global/types';
import remote from '../../../service';

type UpdatePasswordProps = {
  officeId?: number;
  externalCreditorId?: string;
  sessionId?: string;
  password?: string;
};

async function updatePassword({
  officeId,
  externalCreditorId,
  ...payload
}: UpdatePasswordProps): Promise<void> {
  await remote.patch<void>(`/office/${officeId}/user/credential`, payload);
}

export function useUpdatePassword(options?: UseMutationOptions<void>) {
  return useMutation(updatePassword, options);
}
